export default __webpack_public_path__ + "static/transparency-0f445b1f3d7b797e0b5ba39700658f06.png";